// отображение и загрузка файла в дропзоне
import progressbar from "./progressbar";
import dropzoneStates from "./data/states";
import dropzoneFile from "./data/file";
import dropzoneUpload from "./data/upload";
import dropzoneProgress from "./data/progress";

const template = `
    <div class="dropzone-file" v-show="showFile">
        <span>[[ shortName ]]</span>
        <progressbar v-if="!isFinished" class="dropzone-file__progress" :progress="progress">
        </progressbar>
        <div
            @click.prevent="del"
            class="dropzone-file__delete"
            title="Удалить файл"
            data-ref="dropzone-file-delete"
        >
            <i class="fa fa-close"></i>
        </div>
    </div>`;

const props = {
    file: Object,
    index: Number,
    url: String,
};

const data = function () {
    return {
        error: "",
        progress: null,
        isFinished: false,
    };
};

const methods = {
    async upload() {
        try {
            this.result = await dropzoneUpload.uploader(
                this.url,
                this.file,
                this.getProgress.bind(this),
            );
            if (this.result.status === "success") {
                this.onSuccess();
            } else {
                this.setError();
            }
        } catch (e) {
            console.log(e);
            this.setFileState(dropzoneStates.STATES.ERROR);
        } finally {
            this.$emit("uploadingFinished", this.error);
            this.isFinished = true;
        }
    },

    onSuccess() {
        this.setFileState(dropzoneStates.STATES.FINISHED);
        this.file.id = this.result.document.id;
        this.isFinished = true;
    },

    setFileState(state) {
        this.file.state = state;
    },

    setError() {
        this.setFileState(dropzoneStates.STATES.ERROR);
        const errors = [];
        Object.keys(this.result.form.errors)
            .forEach(error => {
                if (error === "__all__") {
                    errors.push(this.result.form.errors[error].pop());
                } else {
                    errors.push(this.result.form.errors[error]);
                }
            });
        if (!errors.length && this.result.message) {
            errors.push(this.result.message);
        }
        this.error = `${this.shortName} — ${errors.join("; ")}`;
    },

    getProgress(e) {
        this.progress = dropzoneProgress.getPercentValue(e);
    },

    del() {
        this.$emit("delete:file", this.index);
    },
};

const computed = {
    shortName() {
        return dropzoneFile.getShortName(this.file.name);
    },

    showFile() {
        return !dropzoneStates.isError(this.file.state);
    },
};

const mounted = async function () {
    if (!dropzoneStates.isFinished(this.file.state)) {
        this.upload();
    } else {
        this.isFinished = true;
    }
};

const emits = ["delete:file", "uploadingFinished"];

export default {
    props,
    data,
    template,
    methods,
    mounted,
    computed,
    components: { progressbar },
    emits,
};
